import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Page404({ homePath = "/" }) {
  const { t } = useTranslation();
  return (

    <div  className="main-content">
    <div className="customer-part">
      <div className="card-box">
    <div className="page-404 d-flex align-items-center justify-content-center min-vh-50 text-center">
      <div className="container">
        <div className="page-404-wrap">
          <article>
            <figcaption>
              <h1 className="mb-4">{t("Oops.The Page you are looking for doesn't exit..")}</h1>
              <p className="mb-4">
                {t("You may have mistyped the address or the page may have moved. Try searching below.")}
              </p>
              <Link className="btn btn-oring px-4 py-2" to={homePath}>
                {t("Back to home")}
              </Link>
            </figcaption>
          </article>
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>
 
  );
}

export default Page404;
